module.exports = __webpack_public_path__ + "img/033-saint-kitts-and-nevis.bf8f9102.svg";